import React from "react";
import { Box, Skeleton } from "@mui/material";

export function TableSkeleton({ rows = 8, columns = 5 }) {
    return (
        <Box sx={{ width: "100%", overflow: "hidden" }}>
            <Box
                sx={{
                    display: "flex",
                    gap: 1,
                    mb: 2,
                    p: 1,
                    bgcolor: "#f0f7ff",
                    borderRadius: 1,
                }}
            >
                {Array.from({ length: columns }).map((_, i) => (
                    <Skeleton
                        key={i}
                        variant="text"
                        width={`${100 / columns}%`}
                        height={40}
                        sx={{ borderRadius: 1 }}
                    />
                ))}
            </Box>
            {Array.from({ length: rows }).map((_, rowIndex) => (
                <Box
                    key={rowIndex}
                    sx={{
                        display: "flex",
                        gap: 1,
                        mb: 1,
                        p: 1,
                        bgcolor: rowIndex % 2 === 0 ? "#fafafa" : "white",
                        borderRadius: 1,
                    }}
                >
                    {Array.from({ length: columns }).map((_, colIndex) => (
                        <Skeleton
                            key={colIndex}
                            variant="text"
                            width={`${100 / columns}%`}
                            height={32}
                            animation="wave"
                        />
                    ))}
                </Box>
            ))}
        </Box>
    );
}

export function SelectorSkeleton({ width = "100%", height = 56 }) {
    return (
        <Skeleton
            variant="rounded"
            width={width}
            height={height}
            animation="wave"
            sx={{ borderRadius: 2 }}
        />
    );
}

export function ChipsSkeleton({ count = 12, gridCols = 4 }) {
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: {
                    xs: "repeat(3, 1fr)",
                    sm: `repeat(${gridCols}, 1fr)`,
                },
                gap: 1,
            }}
        >
            {Array.from({ length: count }).map((_, i) => (
                <Skeleton
                    key={i}
                    variant="rounded"
                    height={36}
                    animation="wave"
                    sx={{ borderRadius: 2 }}
                />
            ))}
        </Box>
    );
}

export function CardsSkeleton({ count = 4, columns = 2 }) {
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: {
                    xs: "1fr",
                    sm: `repeat(${columns}, 1fr)`,
                },
                gap: 2,
            }}
        >
            {Array.from({ length: count }).map((_, i) => (
                <Skeleton
                    key={i}
                    variant="rounded"
                    height={80}
                    animation="wave"
                    sx={{ borderRadius: 2 }}
                />
            ))}
        </Box>
    );
}

export function LoadingOverlay({ message = "Cargando datos..." }) {
    return (
        <Box
            sx={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                bgcolor: "rgba(255, 255, 255, 0.85)",
                backdropFilter: "blur(4px)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 10,
                borderRadius: 2,
            }}
        >
            <Box
                sx={{
                    width: 48,
                    height: 48,
                    border: "3px solid #e3f2fd",
                    borderTop: "3px solid #1565c0",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                    mb: 2,
                    "@keyframes spin": {
                        "0%": { transform: "rotate(0deg)" },
                        "100%": { transform: "rotate(360deg)" },
                    },
                }}
            />
            <Box sx={{ color: "#1565c0", fontWeight: 500, fontSize: "0.875rem" }}>
                {message}
            </Box>
        </Box>
    );
}

const LoadingSkeletonComponents = {
    TableSkeleton,
    SelectorSkeleton,
    ChipsSkeleton,
    CardsSkeleton,
    LoadingOverlay,
};

export default LoadingSkeletonComponents;
